import React from 'react';
import { Link } from 'react-router-dom';
import './Policy.css';

const RefundPolicy = () => (
  <div className="policy-page refund-policy-page">
    <div className="page-header">
      <div className="page-header-content">
        <div className="container">
          <h1>REFUND &amp; CANCELLATION</h1>
          <div className="breadcrumb">
            <Link to="/">Home</Link>
            <span>/</span>
            <span>Refund &amp; Cancellation</span>
          </div>
          <p className="policy-banner-note">Last updated on 12 Sep, 2026</p>
        </div>
      </div>
    </div>
    <section className="policy-content">
      <div className="container">
        <div className="policy-box">
          <h2>DigiRasa – Refund &amp; Cancellation Policy</h2>
          <p>
            <strong>Effective Date:</strong> 12/09/2026
            <br />
            <strong>Last Updated:</strong> 12/09/2026
          </p>
          <p>
            This Refund &amp; Cancellation Policy (“Policy”) applies to orders, meal plans and
            subscriptions purchased through the DigiRasa website, mobile application and other
            authorised DigiRasa ordering channels.
          </p>
          <p>
            DigiRasa is operated by Bulusu Digital Innovations Pvt. Ltd., having its registered
            office at: 9-22/B/20, Boduppal, Ghatkesar, Hyderabad – 500092, Telangana, India.
          </p>
          <p>
            This Policy should be read together with the DigiRasa{' '}
            <Link to="/terms-and-conditions">Terms &amp; Conditions</Link> and{' '}
            <Link to="/privacy-policy">Privacy Policy</Link>.
          </p>

          <h3>1. Order confirmation</h3>
          <p>
            1.1 Customers may select meals, products or subscription plans and proceed to the
            payment stage through the DigiRasa Platform.
          </p>
          <p>
            1.2 An order or subscription is considered successfully placed only after successful
            payment confirmation is received by DigiRasa and DigiRasa generates or communicates the
            applicable order/subscription confirmation.
          </p>
          <p>
            1.3 Merely adding an item to the cart, reaching the payment page, initiating payment,
            receiving a pending status, or receiving a bank debit without DigiRasa confirmation
            does not by itself constitute a successfully placed order.
          </p>
          <p>
            1.4 DigiRasa may contact the customer if payment has been received but the order or
            subscription status requires reconciliation or verification.
          </p>

          <h3>2. Cancellation before payment</h3>
          <p>
            2.1 A customer may leave the checkout process at any time before completing payment.
          </p>
          <p>
            2.2 Where payment has not been successfully completed, no order or subscription shall
            be treated as successfully placed.
          </p>
          <p>
            2.3 No cancellation request is required for an order that has not been successfully
            placed.
          </p>

          <h3>3. Cancellation after successful payment</h3>
          <p>
            3.1 Once an order or subscription has been successfully placed and confirmed,
            cancellation shall be governed by this Policy and the applicable service conditions.
          </p>
          <p>
            3.2 Because DigiRasa meals are prepared and scheduled according to customer orders and
            subscription schedules, cancellation eligibility may depend on the preparation or
            delivery stage of the relevant meal.
          </p>
          <p>
            3.3 For an individual meal order, cancellation requests should be made before the
            applicable preparation cut-off time communicated by DigiRasa.
          </p>
          <p>
            3.4 Once preparation of a meal has commenced, DigiRasa may be unable to accept a
            cancellation request for that meal.
          </p>
          <p>
            3.5 Where cancellation is accepted, any eligible refund shall be processed in
            accordance with this Policy.
          </p>
          <p>
            3.6 Where a cancellation is not eligible for refund because preparation or fulfilment
            has already commenced, the customer will be informed accordingly, subject to applicable
            consumer rights and law.
          </p>

          <h3>4. Subscription cancellation</h3>
          <p>
            4.1 Customers purchasing a DigiRasa subscription should carefully review the selected
            meal plan, duration, meal frequency, start date and applicable charges before
            completing payment.
          </p>
          <p>
            4.2 Cancellation of an active subscription shall be subject to the applicable
            cancellation rules displayed for that subscription plan.
          </p>
          <p>
            4.3 Cancellation of a subscription does not automatically mean that previously
            delivered or prepared meals are refundable.
          </p>
          <p>
            4.4 Any eligible refund for an unused portion of a subscription shall be determined in
            accordance with the applicable cancellation terms, operational status of the
            subscription and applicable law.
          </p>
          <p>
            4.5 Customers may contact DigiRasa customer support to request cancellation or
            clarification regarding their subscription status.
          </p>

          <h3>5. Pause / skip of subscription meals</h3>
          <p>
            5.1 Eligible subscription customers may pause or skip upcoming meals according to the
            pause/skip functionality available through the DigiRasa application, website or
            customer-support channels.
          </p>
          <p>
            5.2 A meal must be skipped or paused at least 24 hours before its scheduled delivery
            time, unless a different cut-off is specifically displayed for the relevant plan or
            service area.
          </p>
          <p>
            5.3 Requests received after the applicable cut-off may not be accepted because meal
            preparation and delivery planning may already have commenced.
          </p>
          <p>
            5.4 Eligible skipped meals are not automatically refunded in cash.
          </p>
          <p>
            5.5 Instead, the corresponding eligible skipped meals shall be carried forward and the
            subscription period shall be extended accordingly.
          </p>
          <p>
            5.6 The extension shall generally correspond to the number of eligible meals/days
            successfully skipped.
          </p>
          <p>
            5.7 Customers may resume a paused subscription through the DigiRasa application,
            website or customer-support channels.
          </p>
          <p>
            5.8 The subscription will resume from the next eligible delivery date after the resume
            request is successfully recorded.
          </p>
          <p>
            5.9 Customers should check their updated subscription schedule/end date after making a
            pause, skip or resume request.
          </p>

          <h3>6. Non-delivery of a confirmed meal</h3>
          <p>
            6.1 If DigiRasa is unable to deliver a confirmed meal due to an issue attributable to
            DigiRasa, the customer should contact customer support as soon as reasonably possible.
          </p>
          <p>
            6.2 DigiRasa may investigate the issue and, depending on the circumstances, provide an
            appropriate remedy such as:
          </p>
          <ul>
            <li>arranging delivery where reasonably possible;</li>
            <li>providing an eligible replacement;</li>
            <li>refunding the affected meal; or</li>
            <li>extending the applicable subscription by the affected meal/day.</li>
          </ul>
          <p>
            6.3 Where delivery could not be completed due to circumstances attributable to the
            customer, such as an incorrect delivery address, unavailable recipient or inability to
            access the delivery location, eligibility for refund or replacement may be affected.
          </p>
          <p>
            6.4 Nothing in this Policy limits any rights or remedies available to customers under
            applicable law.
          </p>

          <h3>7. Missing, incorrect or damaged items</h3>
          <p>
            7.1 Customers should report missing, incorrect or materially damaged items to DigiRasa
            customer support as soon as reasonably possible after delivery.
          </p>
          <p>
            7.2 DigiRasa may request order details, photographs or other reasonable information
            necessary to investigate the complaint.
          </p>
          <p>
            7.3 Depending on the circumstances, DigiRasa may provide a replacement, suitable
            credit, eligible refund or another appropriate resolution.
          </p>

          <h3>8. Food quality complaints</h3>
          <p>
            8.1 Customers who receive a meal with a genuine quality or preparation concern should
            contact DigiRasa customer support promptly.
          </p>
          <p>
            8.2 DigiRasa may review the complaint based on the order details, preparation
            information and supporting evidence provided by the customer.
          </p>
          <p>
            8.3 Where the complaint is found to be valid, DigiRasa may, depending on the
            circumstances, provide an appropriate resolution such as replacement, eligible refund,
            credit or subscription adjustment.
          </p>
          <p>
            8.4 Customers are encouraged to report food-quality concerns as soon as possible after
            receiving the meal.
          </p>

          <h3>9. Allergies and dietary restrictions</h3>
          <p>
            9.1 Customers must inform DigiRasa of known allergies, intolerances or dietary
            restrictions before placing an order.
          </p>
          <p>
            9.2 Customers should review available ingredient and meal information before ordering.
          </p>
          <p>
            9.3 DigiRasa cannot guarantee an allergen-free environment unless a particular product
            or service is expressly identified as allergen-free.
          </p>
          <p>
            9.4 Customisation requests do not automatically guarantee that cross-contact or trace
            exposure will not occur.
          </p>
          <p>
            9.5 Refund eligibility shall not arise merely because a customer subsequently
            identifies an allergy or dietary restriction that was not communicated to DigiRasa
            before ordering, subject to applicable law.
          </p>

          <h3>10. Failed payment where money is debited</h3>
          <p>
            10.1 If a payment attempt fails but the customer&apos;s bank account, card or payment
            instrument has been debited, the transaction must first be verified.
          </p>
          <p>
            10.2 Where DigiRasa does not receive successful payment confirmation and the payment is
            subsequently identified as failed, reversed or unsuccessful, the amount will be
            reconciled through the applicable payment gateway/banking system.
          </p>
          <p>
            10.3 DigiRasa will ordinarily initiate or support the applicable reversal/refund
            process after verification of the failed transaction.
          </p>
          <p>
            10.4 Payment reconciliation/refund will ordinarily be initiated within 5–7 business
            days after the relevant transaction is verified, unless a different period is required
            by the payment gateway, bank or applicable law.
          </p>
          <p>
            10.5 The actual time taken for the amount to appear in the customer&apos;s account may
            depend on the customer&apos;s bank, card issuer or payment service provider.
          </p>

          <h3>11. Payment successful but order not confirmed</h3>
          <p>
            11.1 If payment appears successful but the customer does not immediately receive an
            order or subscription confirmation, the customer should first check the order status in
            the DigiRasa application/website.
          </p>
          <p>
            11.2 The customer may contact DigiRasa customer support with the relevant transaction
            reference.
          </p>
          <p>
            11.3 DigiRasa will verify the payment status with its payment gateway and internal
            order system.
          </p>
          <p>11.4 Where the payment is successfully received, DigiRasa will either:</p>
          <ul>
            <li>confirm the applicable order/subscription; or</li>
            <li>
              initiate the appropriate reconciliation/refund process where the order cannot be
              fulfilled.
            </li>
          </ul>
          <p>
            11.5 Customers should not make repeated payments for the same order merely because
            confirmation is delayed unless specifically instructed by DigiRasa.
          </p>

          <h3>12. Duplicate payments</h3>
          <p>
            12.1 If a customer accidentally completes more than one successful payment for the same
            order or subscription, the customer should contact DigiRasa customer support with the
            relevant transaction details.
          </p>
          <p>
            12.2 DigiRasa will verify whether a duplicate payment has actually been received.
          </p>
          <p>
            12.3 Where an excess/duplicate payment is confirmed, DigiRasa will initiate the
            applicable refund or reversal process.
          </p>
          <p>
            12.4 Such refund/reversal will ordinarily be initiated within 5–7 business days after
            verification, subject to payment-provider and banking timelines.
          </p>

          <h3>13. Refund processing</h3>
          <p>
            13.1 Where a refund is approved, DigiRasa will normally process the refund through the
            original payment method or another appropriate method permitted by the payment provider
            and applicable law.
          </p>
          <p>
            13.2 DigiRasa will not normally provide cash refunds where the original transaction was
            completed through a digital payment method, unless otherwise required or permitted.
          </p>
          <p>
            13.3 The time taken for the refunded amount to reflect in the customer&apos;s account
            depends on the relevant bank, card issuer or payment gateway.
          </p>
          <p>
            13.4 Customers should retain payment references and transaction details until the
            refund has been successfully credited.
          </p>

          <h3>14. Refund eligibility</h3>
          <p>
            14.1 Refunds may be considered, subject to applicable law and the circumstances of the
            order, where:
          </p>
          <ul>
            <li>DigiRasa is unable to fulfil a confirmed order;</li>
            <li>DigiRasa confirms a duplicate payment;</li>
            <li>a payment is successfully received but the order cannot be fulfilled;</li>
            <li>DigiRasa approves a valid cancellation under this Policy;</li>
            <li>
              a confirmed meal is not delivered due to reasons attributable to DigiRasa; or
            </li>
            <li>another refund is required under applicable law.</li>
          </ul>
          <p>
            14.2 The nature and amount of the refund may depend on the specific order, meal,
            subscription, delivery status and circumstances.
          </p>
          <p>
            14.3 A skipped subscription meal that is properly reported within the applicable
            cut-off will normally be carried forward through subscription extension rather than
            refunded in cash.
          </p>

          <h3>15. Cases where refund may not be available</h3>
          <p>
            Subject to applicable law, a refund may not be available where:
          </p>
          <p>15.1 The customer cancels after the applicable preparation cut-off time.</p>
          <p>15.2 The meal has already been prepared or dispatched.</p>
          <p>15.3 The customer provides an incorrect or incomplete delivery address.</p>
          <p>15.4 The customer is unavailable to receive the order after reasonable delivery attempts.</p>
          <p>
            15.5 The customer refuses or declines delivery for reasons unrelated to a DigiRasa
            service failure.
          </p>
          <p>15.6 The customer fails to report an eligible issue within a reasonable period.</p>
          <p>
            15.7 A customer requests a refund solely because they did not like a particular food
            preference or taste, unless DigiRasa determines otherwise under its customer-support
            policy or applicable law.
          </p>
          <p>
            15.8 The customer provides information or circumstances that materially differ from the
            order placed.
          </p>
          <p>
            Nothing in this section shall exclude a refund, replacement or other remedy where
            required by applicable law.
          </p>

          <h3>16. Promotions, discounts and coupons</h3>
          <p>
            16.1 Promotional discounts, coupons, referral benefits and special offers may have
            separate terms and validity periods.
          </p>
          <p>
            16.2 Where an order placed using a promotional benefit is cancelled or refunded, the
            value of the promotional benefit may be treated in accordance with the applicable
            promotional terms.
          </p>
          <p>
            16.3 Promotional amounts are not necessarily refundable as cash unless expressly stated
            otherwise.
          </p>

          <h3>17. Subscription end-date extension</h3>
          <p>
            17.1 Where DigiRasa confirms an eligible skipped meal, paused meal or non-delivery
            adjustment that is to be carried forward, the subscription duration/end date shall be
            adjusted accordingly.
          </p>
          <p>
            17.2 The revised end date shall depend on the number of eligible meals/days added back
            to the subscription.
          </p>
          <p>
            17.3 Customers should check the updated subscription details through the DigiRasa
            application/website or customer support.
          </p>

          <h3>18. Customer support for refund / cancellation requests</h3>
          <p>Customers may contact DigiRasa using the following details:</p>
          <p>
            Email:{' '}
            <a href="mailto:customercare@digirasa.com">customercare@digirasa.com</a>
            <br />
            Phone: <a href="tel:+918143231857">+91 8143231857</a>
          </p>
          <p>When contacting DigiRasa, customers should provide:</p>
          <ul>
            <li>Order/subscription ID;</li>
            <li>Registered mobile number;</li>
            <li>Payment/transaction reference, where applicable;</li>
            <li>Date of transaction/order; and</li>
            <li>A brief description of the issue.</li>
          </ul>
          <p>
            Providing complete information helps DigiRasa verify the request and process it
            efficiently.
          </p>

          <h3>19. Force majeure and unforeseen events</h3>
          <p>
            19.1 DigiRasa may be unable to fulfil or may experience delays in fulfilling an order
            due to circumstances beyond its reasonable control, including extreme weather, natural
            disasters, government restrictions, transportation disruptions, major technical
            failures, public emergencies, strikes or other force majeure events.
          </p>
          <p>
            19.2 Where a confirmed order cannot reasonably be fulfilled due to such circumstances,
            DigiRasa will take reasonable steps to inform the customer and provide an appropriate
            solution subject to the circumstances and applicable law.
          </p>

          <h3>20. Policy changes</h3>
          <p>
            20.1 DigiRasa may update or modify this Refund &amp; Cancellation Policy from time to
            time.
          </p>
          <p>
            20.2 The latest version will be made available on the DigiRasa website and/or
            application.
          </p>
          <p>
            20.3 Any updated policy shall apply from the effective date stated in the updated
            version, subject to applicable law.
          </p>

          <h3>21. Governing law</h3>
          <p>21.1 This Policy shall be governed by the laws of India.</p>
          <p>
            21.2 Any dispute shall be handled in accordance with applicable law and the
            jurisdiction provisions contained in DigiRasa’s{' '}
            <Link to="/terms-and-conditions">Terms &amp; Conditions</Link>.
          </p>

          <h3>22. Important payment-page notice</h3>
          <p>
            Before completing payment, please review your selected meal/order, subscription plan,
            delivery address, schedule, price, applicable GST, delivery charges and other
            applicable charges.
          </p>
          <p>
            Once payment is successfully confirmed and DigiRasa confirms the order/subscription, the
            order will be treated as successfully placed and the applicable cancellation, pause,
            skip and refund rules in this Policy will apply.
          </p>
          <p>
            For eligible subscription pauses/skips, the affected meals will generally be carried
            forward by extending the subscription rather than providing a cash refund.
          </p>
          <p>
            By completing payment, you acknowledge that you have read and understood this Refund
            &amp; Cancellation Policy and the applicable DigiRasa Terms &amp; Conditions.
          </p>

          <div className="policy-help-box">
            <h3>DigiRasa</h3>
            <p>Operated by Bulusu Digital Innovations Pvt. Ltd.</p>
            <p>
              <strong>Registered Office:</strong>
              <br />
              9-22/B/20, Boduppal, Ghatkesar,
              <br />
              Hyderabad – 500092, Telangana, India.
            </p>
            <p>
              <strong>Kitchen Address:</strong>
              <br />
              Plot No: HIG-137, Huda Complex, Mayuri Nagar,
              <br />
              Hyderabad – 500092, Telangana, India
            </p>
            <p>
              <strong>Customer Support:</strong>{' '}
              <a href="mailto:customercare@digirasa.com">customercare@digirasa.com</a>
              {' | '}
              <a href="tel:+918143231857">+91 8143231857</a>
            </p>
          </div>
        </div>
      </div>
    </section>
  </div>
);

export default RefundPolicy;
